import CashierPinLoginPage from '../../cashier/pages/CashierPinLoginPage';

/**
 * Pharmacy SPA login — PIN for cashiers / desktop (same Identity cashier-pin API as grocery).
 * Office handoff stays on /auth/accept after aurent.uz.
 */
export default function LoginPage() {
  return <CashierPinLoginPage />;
}
